import { Vue } from 'vue-class-component';
import HelpScreen from '../help-screen/index.vue';
import moment from 'moment';
import store from '@/store';
import { EventEmitter } from 'events';
import { AppInsights } from '@/appInsights';
import AlertBox from '../alert-box/index.vue';
import { CommitteeView, EmploymentDetail, Meeting, PersonalDetail, CommitteeContactDetail, EoiFormView, MeetingWithFiles, ModelFile } from '@/modules/typescript-cmpApi-client/models';
import { Inject, Options } from 'vue-property-decorator';
import { CMPApi } from '@/modules/cmp-api';
import { AuthorizedUser } from '@/models/authorized-user';
import DetailsEdit from '@/components/details-edit/index.vue';
import LoadingSpinner from '../loading-spinner/index.vue';
import HelpText from '../../assets/config/help-text.json';
import { forEach, orderBy } from 'lodash';

@Options<Dashboard>({
  components: {
    HelpScreen,
    DetailsEdit,
    LoadingSpinner,
    AlertBox
  }
})


export default class Dashboard extends Vue {

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;
  private showHelpScreen = false;
  private showModalDetailsEdit = false;
  private userName = '';
  private isPcHolder = false;
  private isNewMember = true;

  private comingCommitteeYear: any;
  private isInEoiPeriod = false;
  private isInEoiPeriodManual = false;
  private comingCommitteeName = '';
  private comingCommitteeYearStart = '';
  private comingCommitteeYearEnd = '';
  private committeeYearStart = '';
  private eoiPeriodStart = '';
  private eoiPeriodEnd = '';
  private hasAssessedEoiForm = false;
  private eoiForm: EoiFormView = {};

  private eoiSubmittedOn = '';

  private currentCommitteeYear: any;
  private currentCommitteeName = '';
  private currentCommitteeYearStart = '';
  private currentCommitteeYearEnd = '';

  private employmentDetail: EmploymentDetail = {};
  private personalDetail: PersonalDetail = {};
  private committeeContactDetail: CommitteeContactDetail = {};

  private address = '';

  private myCommittees: CommitteeView[] = [];
  private meeting: Meeting = {};

  private authorizedUser = new AuthorizedUser;
  private editType = 0; // 1 - Personal, 2 - Employment, 3 - Committee Contact;

  private isLoadingData = false;
  private errorLoading = false;

  private countryList = [];

  private showCancelAlertBox = false;
  private selectedMeeting: MeetingWithFiles = {};
  private selectedCommittee: CommitteeView = {};
  private disclosure = '';

  get pageHeader(): string {
    return HelpText[0].dashboard.pageHeading;
  }

  get pageDescription(): string {
    return HelpText[0].dashboard.pageDescription;
  }

  get pageSection(): any[] {
    return HelpText[0].dashboard.section;
  }

  get isEoiBeingAssessed(): boolean {
    let _isEoiBeingAssessed = false;
    if (this.eoiForm && this.eoiForm.committeeMembers && this.eoiForm.committeeMembers.length > 0) {
      for (let i = 0; i < this.eoiForm.committeeMembers.length; i++) {
        if (this.eoiForm.committeeMembers[i].stage1EoiFormStatusId  !== null){
          _isEoiBeingAssessed = true;
        }
        if (this.eoiForm.committeeMembers[i].stage2EoiFormStatusId  !== null){
          _isEoiBeingAssessed = true;
        }
      }
    }
    return _isEoiBeingAssessed;
  }

  private getMeetingDateTime(d: any) {
    return moment(d).format('DD MMM YYYY').toUpperCase();
  }
  
  private getMeetingType(t: Meeting) {
    let _meetingTypes = '';
    t.meetingTypes.forEach((mt: any) => {
      _meetingTypes += ' | ' + mt.name;
    })
    return _meetingTypes;
  }

  private getMeetingName(committee: CommitteeView) {
    const files = committee.meeting.files;
    files.sort(function (obj1: any, obj2: any) {
      // reverse sort the file creation time
      return moment(obj2.createdOn).unix() - moment(obj1.createdOn).unix();
    });
    return files[0].name;
  }

  private getPhoneNumber() {
    return (this.committeeContactDetail.phone.phoneAreaCode || '') + ' ' + (this.committeeContactDetail.phone.phoneNumber || '');
  }

  private getAddressEncoded() {
    let address = this.committeeContactDetail.address;
    const countryName: string = address['countryName'];
    let addressEncoded = '';
    address = JSON.parse(JSON.stringify(address).replace(/:null/gi, ':""'));  // replace all null value
    if (countryName.toLowerCase() == 'australia') {
      switch (address['addressTypeId']) {
        case 1: // Street
          addressEncoded = address['buildingName'] + '\n';
          addressEncoded += address['buildingTypeName'] + ' ' + address['buildingNumber'] + ' ' + address['level'] + '\n';
          addressEncoded += address['streetNumber'] + ' ' + address['streetName'] + ' ' + address['streetTypeName'] + '\n';
          addressEncoded += address['suburbName'] + ', ' + address['stateName'] + ' ' + address['postcode'];
          break;
        case 2: // PO Box
          addressEncoded = address['deliveryTypeName'] + ' ' + address['poBox'] + '\n';
          addressEncoded += address['suburbName'] + ', ' + address['stateName'] + ' ' + address['postcode'];
          break;
        // case 3: // DX address
        //   addressEncoded = 'DX ' + address['dxNumber'] + '\n';
        //   addressEncoded += address['dxExchangeTypeName'] + '\n';
        //   break;
      }
    } else {
      addressEncoded = this.committeeContactDetail.address['foreignAddress'] + '\n' + this.committeeContactDetail.address['countryName'];
    }
    return addressEncoded.trim();
  }
  
  mounted() {
    window.sessionStorage.removeItem('eoiPageSection');
    window.sessionStorage.removeItem('eoiForm');
    window.sessionStorage.removeItem('areaOfInterests');
    window.sessionStorage.removeItem('emailPreferences');
    // clear any query string parameters
    this.$router.replace('/dashboard');

    this.userName = this.userAccount.user.firstName + ' ' + this.userAccount.user.lastName;
    this.isPcHolder = this.userAccount.user.isPcHolder || false;

    this.isLoadingData = true;
    this.errorLoading = false;

    Promise.all([
      this.getComingCommitteeYear(),
      this.getCurrentCommitteeYear(),
      this.getMyCommittees(),
      this.getIsNewMember(),
      this.getMyMemberDetails()
    ]).then((res) => {
      this.isLoadingData = false;
      if (!this.hasAssessedEoiForm) {
        this.getMyEoiForm();
      }
    }).catch((err) => {
      this.errorLoading = true;
      this.isLoadingData = false;
      this.ai.trackException('Error getting promise.all: ' + err);
    });

    this.getCountryList();
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  private contactUs() {
    window.open("https://www.lawsociety.com.au/contact-us", "blank");
  }

  private getCountryList() {
    // background load countryList for later use
    const countryList = store.getters.getCountryList;
    this.countryList = countryList == null ? null : JSON.parse(countryList);

    if (this.countryList == null) {
      this.apiService.CodeApi?.apiV1CodeGetCountriesGet()
        .then((res: any) => {
          this.countryList = res.data.data;
          store.dispatch('setCountryList', this.countryList);
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting country list: ' + !!err.response.status ? err.response.status : err);
          this.ai.trackException('Error getting country list: ' + err);
        })
    }
  }

  private async getComingCommitteeYear(): Promise<boolean> {

    try {
      const res: any = await this.apiService.committeeApi?.apiV1CommitteeGetComingYearGet();
      this.comingCommitteeYear = res.data.data;
      this.comingCommitteeName = this.comingCommitteeYear.name;
      this.isInEoiPeriod = this.comingCommitteeYear.isInEoiPeriod;
      this.isInEoiPeriodManual = this.comingCommitteeYear.isInEoiPeriodManual;
      this.hasAssessedEoiForm = this.comingCommitteeYear.hasAssessedEoiForm;
      this.comingCommitteeYearStart = moment(this.comingCommitteeYear.committeeYearStart).format('DD MMM YYYY').toUpperCase();
      this.comingCommitteeYearEnd = moment(this.comingCommitteeYear.committeeYearEnd).format('DD MMM YYYY').toUpperCase();
      this.eoiPeriodStart = moment(this.comingCommitteeYear.eoiPeriodStart).format('DD MMM YYYY').toUpperCase();
      this.eoiPeriodEnd = moment(this.comingCommitteeYear.eoiPeriodEnd).format('DD MMM YYYY').toUpperCase();
      this.committeeYearStart = moment(this.comingCommitteeYear.committeeYearStart).format('YYYY');
      return Promise.resolve(false);

    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Committee year info: ' + !!err.response.status ? err.response.status : err);
      this.ai.trackException('Error getting committee year info: ' + err);
      return Promise.reject(false);
    }

  }


  private async getCurrentCommitteeYear(): Promise<boolean> {

    try {
      const res: any = await this.apiService.committeeApi?.apiV1CommitteeGetCurrentYearGet();
      this.currentCommitteeYear = res.data.data;
      this.currentCommitteeYearStart = moment(this.currentCommitteeYear.committeeYearStart).format('DD MMM YYYY').toUpperCase();
      this.currentCommitteeYearEnd = moment(this.currentCommitteeYear.committeeYearEnd).format('DD MMM YYYY').toUpperCase();
      this.currentCommitteeName = this.currentCommitteeYear.name;

      return Promise.resolve(false);

    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Committee year info: ' + !!err.response.status ? err.response.status : err);
      this.ai.trackException('Error getting committee year info: ' + err);
      return Promise.reject(false);
    }

  }

  private async getMyCommittees(): Promise<boolean> {
    try {
      
      const res: any = await this.apiService.memberApi?.apiV1MemberGetMyCommitteesGet();
      this.myCommittees = res.data.data;
      store.dispatch('setMyCommittees', this.myCommittees);
      return Promise.resolve(false);

    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting EOI Committee info: ' + !!err.response.status ? err.response.status : err);
      this.ai.trackException('Error getting EOI committee info: ' + err);
      return Promise.reject(false);
    }

  }

  private async getIsNewMember(): Promise<boolean> {
    try {
      const res: any = await this.apiService.memberApi?.apiV1MemberIsNewMemberGet();
      this.isNewMember = res.data.data;
      return Promise.resolve(false);
    } catch (err) {
      console.log(err);
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Member status: ' + !!err.response.status ? err.response.status : err);
      this.ai.trackException('Error getting Member status: ' + err);
      return Promise.reject(false);
    }
  }

  private async getMyMemberDetails(): Promise<boolean> {

    try {
      const res: any = await this.apiService.memberApi?.apiV1MemberGetMyMemberDetailGet();
      store.dispatch('setMyMemberDetails', res.data.data);
      this.personalDetail = res.data.data.personalDetail;
      this.employmentDetail = res.data.data.employmentDetail;
      this.committeeContactDetail = res.data.data.committeeContactDetail;
      this.address = this.committeeContactDetail.address;
      return Promise.resolve(false);

    } catch (err) {
      console.log(err);
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My Member Details: ' + !!err.response.status ? err.response.status : err);
      this.ai.trackException('Error getting details info: ' + err);
      return Promise.reject(false);
    }

  }

  private async getMyEoiForm(): Promise<boolean> {
    try {
      const res: any = await this.apiService.memberApi?.apiV1MemberGetMyEoiFormGet();
      store.dispatch('setEoiForm', res.data.data);
      this.eoiForm = res.data.data;
      if (this.eoiForm !== null) {
        this.eoiSubmittedOn = moment(this.eoiForm.submittedOn).format('DD MMM YYYY').toUpperCase();
      }
      return Promise.resolve(false);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My EOI Details: ' + !!err.response.status ? err.response.status : err);
      this.ai.trackException('Error getting EOI info: ' + err);
      return Promise.reject(false);
    }

  }

  private eoiReview() {
    const pageSection = 'review';
    store.dispatch('setEoiForm', this.eoiForm);
    this.$router.push({ name: 'EoiReview', query: { sec: pageSection, committeeYear: this.comingCommitteeYear.committeeYear } });
  }

  private eoiApply() {
    let isNewEoiForm = false;
    let pageSection = 'overview';
    if (this.eoiForm == null) {
      isNewEoiForm = true;
      store.dispatch('setEoiForm', null);
      this.eoiFormInit();
      store.dispatch('setEoiForm', this.eoiForm);
    }
    if (!isNewEoiForm) {
      pageSection = 'review';
    }
    this.$router.push({ name: 'EoiApply', query: { sec: pageSection, committeeYear: this.comingCommitteeYear.committeeYear } });
  }

  private showEditModal(n: number) {
    this.editType = n;
    this.showModalDetailsEdit = true;
  }

  private agendaClicked(meeting: any, committeeId: number) {
    this.selectedMeeting = meeting;
    const _selectedCommittee = this.myCommittees.filter((c) => {
      return c.id === committeeId;
    });
    this.selectedCommittee = _selectedCommittee[0];
    this.disclosure = this.selectedCommittee.disclosure;
    if (this.selectedCommittee.isUseDisclosure) {
      this.showCancelAlertBox = true;
    } else {
      this.agendaViewing();
    }
  }

  private agendaViewing() {
    const _agendaFile = this.selectedMeeting.files.filter((mf: any)=>{
      return mf.fileTypeName == 'Agenda';
    }) 
    const fileId = _agendaFile[0].id;
    this.$router.push({ name: 'Committee', query: { 'fileId': (fileId).toString(), 'committeeId': this.selectedCommittee.id.toString() } });
  }

  private generalFileClicked(fileId: number, committeeId: number) {
    if (fileId < 0) {
      // get the latest file
      const _thisCommittee = this.myCommittees.filter((c) => {
        return c.id === committeeId;
      });
      const _files = _thisCommittee[0].files;
      _files.sort(function (obj1: any, obj2: any) {
        // reverse sort the file creation time
        return moment(obj2.createdOn).unix() - moment(obj1.createdOn).unix();
      });
      fileId = _files[0].id;
    }
    this.$router.push({ name: 'General', query: { 'fileId': (fileId).toString(), 'committeeId': committeeId.toString() } });
  }

  private fileListSort(files: ModelFile[]) {
    if (files !== null && files.length > 0) {
      return orderBy(
        files,
        ['createdOn'],
        ['desc']
      ).slice(0,3);
    }
  }

  private eoiFormInit() {
    // with minimum properties
    this.eoiForm = {};
    this.eoiForm.yearId = this.comingCommitteeYear.id;
    this.eoiForm.memberId = 0;
    this.eoiForm.acceptOverview = false;
    this.eoiForm.acceptPersonalInfoCollectNotice = null;
    this.eoiForm.confirmEmployeeDetails = null;
    this.eoiForm.confirmPersonalDetails = null;
    this.eoiForm.confirmCommitteeContactDetails = null;
    this.eoiForm.committeeMembers = [];
    this.eoiForm.isSingleCommitteeOnly = null;
    this.eoiForm.response1 = '';
    this.eoiForm.response2 = '';
    this.eoiForm.response3 = '';

    // Temp value for store the end of EOI period.
    this.eoiForm.year = this.comingCommitteeYear;

  }

}

